import ApiRouteNamesResolver from './ApiRouteNamesResolver';
import ClientRouteNamesResolver from './ClientRouteNamesResolver';
import PermissionsNamesResolver from './PermissionsNamesResolver';
import {INamesResolver} from '@src/@interfaces/services/NameResolvers/INamesResolver';
import {IApiRouteNamesResolver} from '@src/@interfaces/services/NameResolvers/IApiRouteNamesResolver';
import {IClientRouteNamesResolver} from '@src/@interfaces/services/NameResolvers/IClientRouteNamesResolver';
import {IPermissionsNamesResolver} from '@src/@interfaces/services/NameResolvers/IPermissionsNamesResolver';
import {IUserPreferencesNamesResolver} from '@src/@interfaces/services/NameResolvers/IUserPreferencesNamesResolver';
import UserPreferencesNamesResolver from './UserPreferencesNamesResolver';
import {IQueryKeysNamesResolver} from '@src/@interfaces/services/NameResolvers/IQueryKeysNamesResolver';
import QueryKeysNameResolver from './QueryKeysNameResolver';
import {IListNamesResolver} from '@src/@interfaces/services/NameResolvers/IListNamesResolver';
import ListNamesResolver from '@src/services/NameResolvers/ListNamesResolver';

export default class NamesResolver implements INamesResolver {
    protected apiRoutesResolver: IApiRouteNamesResolver | null = null;
    protected clientRoutesResolver: IClientRouteNamesResolver | null = null;
    protected permissionsResolver: IPermissionsNamesResolver | null = null;
    protected userPreferencesResolver: IUserPreferencesNamesResolver | null = null;
    protected queryKeysResolver: IQueryKeysNamesResolver | null = null;
    protected listNamesResolver: IListNamesResolver | null = null;

    get apiRoutes() {
        return this.apiRoutesResolver ??= new ApiRouteNamesResolver();
    }

    get clientRoutes() {
        return this.clientRoutesResolver ??= new ClientRouteNamesResolver();
    }

    get permissions() {
        return this.permissionsResolver ??= new PermissionsNamesResolver();
    }

    get userPreferences() {
        return this.userPreferencesResolver ??= new UserPreferencesNamesResolver();
    }

    get queryKeys() {
        return this.queryKeysResolver ??= new QueryKeysNameResolver();
    }

    get listNames() {
        return this.listNamesResolver ??= new ListNamesResolver();
    }
}
